import { boardKind } from "./api/fieldApi";

/**
 * '움직이지 않는 전시'(정적 전시)의 이유 — 제어 평면 규칙(UploadService.prepare):
 *   staticOnly = Bench 프로젝트 없음 || board ≠ spike || 컴파일러 wheelWarning(구동 바퀴에 모터가 닿지 않음).
 * 학생 화면은 가진 데이터(고른 프로젝트 · 스냅샷 board)로 이유를 고르고, 모르면 일반 안내(noProgram)를 쓴다.
 * 기본 프로그램은 없다 — 학생 자신의 Bench 프로그램이 있어야 움직인다(리모컨도 프로그램에 입력만 준다).
 */
export type StaticReason = "noProgram" | "microbit" | "wheels";

/**
 * 정적 전시의 이유. board: 스냅샷·검증 응답의 board(null/"" = 프로그램 없이 올림 · undefined = 모름).
 * 정적인 작품에만 쓴다 — SPIKE 인데 정적이면 남은 이유는 구동 실패(wheelWarning)뿐이다.
 */
export function staticReason(board: string | null | undefined): StaticReason {
  if (!board) return "noProgram";
  const k = boardKind(board);
  if (k === "spike") return "wheels";
  if (k === "microbit") return "microbit";
  return "noProgram";
}

/** 이유별 문구 키 — why(이유 한 줄) · next(다음 행동) · short(카드 한 줄) · pico(피코 확인 말풍선) */
export const STATIC_TEXT: Record<
  StaticReason,
  { why: string; next: string; short: string; pico: string }
> = {
  noProgram: {
    why: "student.static.noProgram.why",
    next: "student.static.noProgram.next",
    short: "student.static.noProgram.short",
    pico: "student.upload.pico.staticNoProgram",
  },
  microbit: {
    why: "student.static.microbit.why",
    next: "student.static.microbit.next",
    short: "student.static.microbit.short",
    pico: "student.upload.pico.staticMicrobit",
  },
  wheels: {
    why: "student.static.wheels.why",
    next: "student.static.wheels.next",
    short: "student.static.wheels.short",
    pico: "student.upload.pico.staticWheels",
  },
};

/** Bench 주소(개발·배포 설정) — 없으면 Bench 로 가는 버튼을 그리지 않는다(문구 안내만) */
export function benchUrl(): string | null {
  return import.meta.env.VITE_BENCH_URL || null;
}
